import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <span>🌍</span>
            <div>
              <span className="logo-african">African</span>
              <span className="logo-marketplace"> Marketplace</span>
            </div>
          </div>
          <p className="footer-tagline">Connecting African communities with trusted service providers.</p>
          <div className="footer-socials">
            <a href="#" aria-label="Instagram">📸</a>
            <a href="#" aria-label="Facebook">👥</a>
            <a href="#" aria-label="Twitter">🐦</a>
          </div>
        </div>

        <div className="footer-links-grid">
          <div className="footer-col">
            <h4>Categories</h4>
            <Link to="/browse?category=food-catering">Food & Catering</Link>
            <Link to="/browse?category=hair-beauty">Hair & Beauty</Link>
            <Link to="/browse?category=tailoring">Tailoring</Link>
            <Link to="/browse?category=event-planning">Event Planning</Link>
          </div>
          <div className="footer-col">
            <h4>For Sellers</h4>
            <Link to="/register?role=seller">Become a Seller</Link>
            <Link to="/dashboard/seller">Seller Dashboard</Link>
            <Link to="/dashboard/seller/create">List a Service</Link>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} African Marketplace. All rights reserved.</p>
        <p className="footer-made">Made with ❤️ for the African community</p>
      </div>
    </footer>
  );
}
